module.exports = __webpack_public_path__ + "static/media/foto4.02fb0726.png";